<template>
  <svg :width="width" :height="height" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path xmlns="http://www.w3.org/2000/svg" d="M20 9.275C20 9.8 19 10.15 17.8333 10.325C17.0833 8.8375 15.5833 7.7 13.8333 6.9125C14 6.65 14.1667 6.475 14.3333 6.2125H15C17.5833 6.125 20 7.7875 20 9.275ZM5.66667 6.125H5C2.41667 6.125 0 7.7875 0 9.275C0 9.8 1 10.15 2.16667 10.325C2.91667 8.8375 4.41667 7.7 6.16667 6.9125L5.66667 6.125ZM10 7C11.8333 7 13.3333 5.425 13.3333 3.5C13.3333 1.575 11.8333 0 10 0C8.16667 0 6.66667 1.575 6.66667 3.5C6.66667 5.425 8.16667 7 10 7ZM10 7.875C6.58333 7.875 3.33333 10.15 3.33333 12.25C3.33333 14 10 14 10 14C10 14 16.6667 14 16.6667 12.25C16.6667 10.15 13.4167 7.875 10 7.875ZM14.75 5.25H15C16.4167 5.25 17.5 4.1125 17.5 2.625C17.5 1.1375 16.4167 0 15 0C14.5833 0 14.25 0.0875002 13.9167 0.2625C14.5833 1.1375 15 2.275 15 3.5C15 4.1125 14.9167 4.725 14.75 5.25ZM5 5.25H5.25C5.08333 4.725 5 4.1125 5 3.5C5 2.275 5.41667 1.1375 6.08333 0.2625C5.75 0.0875002 5.41667 0 5 0C3.58333 0 2.5 1.1375 2.5 2.625C2.5 4.1125 3.58333 5.25 5 5.25Z" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 20 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.iconArinet }
  }
}
</script>